module.exports = __webpack_public_path__ + "media/images/85/about-b8615979fdced188ce79ec2680dc2912.jpg";